import React from 'react';
const PublicRoute = ({ component: Component, location, ...rest }) => (
  <Component location={location} {...rest} />
);
export default PublicRoute;
